import {useLanguage} from "../contexts/LanguageContext.tsx";

import MainLayout from "../layouts/MainLayout.tsx";
import {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";

const JobOffers = () => {
    const { translations } = useLanguage();

    const [jobCollection, setJobCollection] = useState<number>(0)
    const email = import.meta.env.VITE_MAIL;

    const listJobCollection = [
        {
            title: 'HR Manager',
            description: 'On site | Tunis, Tunisia',
            collection: 2,
            link: '/Job_offer_HR-Manager_Tunis.pdf',
        },
        {
            title: '(Junior) IT Administrator',
            description: 'On site | Tunis, Tunisia',
            collection: 2,
            link: '/Job_offer_IT-Administrator_Tunis.pdf',

        },
        {
            title: 'Fullstack Developer',
            description: 'On site | Tunis, Tunisia',
            collection: 2,
            link:'/Job_offer_Fullstack_developer_Tunis.pdf'

        },
        {
            title: 'Data Scientist',
            description: 'On site | Dubai, UAE',
            collection: 3,
            link:'/Job_offer_Data_Scientist_UAE.pdf'
        },
        {
            title: 'AI Developer',
            description: 'On site | Dubai, UAE',
            collection: 3,
            link: '/Job_offer_AI_Developer_UAE.pdf'
        },
        {
            title: 'Speculative Application',
            description: `On site | ${translations.All_locations}`,
            collection: 0,
            link: `mailto:${email}`
        }
    ]


    const jobOffer: any = useParams();
    const navigate = useNavigate();

    const handleButtonClick = (country: string, tab: number) => {
         if (country.length > 0) {

             navigate(`/job-offers/${country}`);
             setJobCollection(tab)
         }
    }


    useEffect(() => {
         if (jobOffer.country && jobOffer.country.trim().length > 0 ) {
            switch (jobOffer.country) {
                case 'german' :
                    setJobCollection(1)
                    break;
                case 'tunisie' :
                    setJobCollection(2)
                    break;
                case 'dubai' :
                    setJobCollection(3)
                    break;
            }
        }
        window.scrollTo(0, 0)

    }, []);

    return (

        <MainLayout>
            <div className="relative mt-20">
                <img
                    src="/assets/Pictures/Career_Header.jpg"
                    alt="Hero Background"
                    className="object-cover h-[144px] w-full md:h-auto "
                />
            </div>
            <div className="bg-[#AEBCC5] p-5 block">
                <div className="flex gap-6 flex-wrap">
                    <div className="w-full md:w-[30%]">
                        <h6 className="text2xl md:text-5xl text-white text-left md:text-right">{translations.Jobangebote} </h6>

                    </div>
                    <div className="w-full md:w-[50%] mt-3">
                        <div className=" flex items-center">

                            <div className="flex flex-wrap gap-3">
                                <button
                                    onClick={() => handleButtonClick('all', 0)}
                                    className={`text-white border-2 font-medium border-white text-sm p-2 rounded min-w-[150px] 
                                    ${jobCollection === 0 ? 'bg-[#88A9AB]': 'bg-transparent'}`}
                                >
                                    {translations.All_locations}
                                </button>

                                <button
                                    onClick={() => handleButtonClick('german', 1)}
                                    className={`text-white border-2 font-medium border-white text-sm p-2 rounded  min-w-[150px]
                                    ${jobCollection === 1 ? 'bg-[#88A9AB]': 'bg-transparent'}`}
                                >
                                    Braunschweig
                                </button>

                                <button
                                    onClick={() => handleButtonClick('tunisie', 2)}
                                    className={`text-white border-2 font-medium border-white text-sm p-2 rounded min-w-[150px] 
                                    ${jobCollection === 2 ? 'bg-[#88A9AB]': 'bg-transparent'}`}
                                >
                                    Tunis
                                </button>

                                <button
                                    onClick={() => handleButtonClick('dubai', 3)}
                                    className={`text-white border-2 font-medium border-white text-sm p-2 rounded min-w-[150px] 
                                    ${jobCollection === 3 ? 'bg-[#88A9AB]': 'bg-transparent'}`}
                                >
                                    Dubai
                                </button>

                            </div>
                        </div>
                        <div className="mt-5 min-h-[80vh]">
                                {listJobCollection.map((item, index) => {
                                    return <div key={index}>
                                    {jobCollection === 0 &&
                                        <a href={item.link} target="_blank"
                                           className="rounded border mt-3 border-black p-4 flex justify-between items-center gap-2 bg-white">

                                            <div>

                                                <h6 className="text-[#D60327] text-[20px]">{item.title}
                                                    <span className="text-[#BFCAD1] ml-3">(m/w/x) </span>
                                                </h6>
                                                <p className="text-[#373F4A]">{item.description} </p>
                                            </div>
                                            <div className="w-[50px]">
                                                <h6 className="text-right text-3xl"> {'>'} </h6>


                                            </div>

                                        </a>
                                    }

                                    {jobCollection !== 0 && (item.collection === jobCollection  || item.collection === 0)&&

                                        <a href={item.link} target="_blank" key={index} className="rounded border mt-3 border-black p-4 flex gap-2 bg-white">

                                            <div>
                                                <h6 className="text-[#D60327] text-[20px]">{item.title}
                                                    <span className="text-[#BFCAD1] ml-3">(m/w/x) </span>
                                                </h6>
                                                <p className="text-[#373F4A]">{item.description} </p>
                                            </div>
                                            <div className="w-[50px]">

                                            </div>


                                        </a>
                                    }
                                    </div>

                                })}

                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default JobOffers;
